import { useMemo } from 'react';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { GroupForm, type GroupFormValues } from '@/components/organisms/settings-groups/GroupForm';
import { useCreateGroup } from '@/hooks/settings/useGroups';
import { useUsers } from '@/hooks/settings/useUsers';

export const Route = createFileRoute('/_dashboard/dashboard/settings/groups/new')({
  component: NewGroupRoute,
});

function NewGroupRoute() {
  const router = useRouter();
  const { data: usersData } = useUsers();
  const users = useMemo(() => usersData?.data ?? [], [usersData?.data]);
  const createGroup = useCreateGroup();

  function close() {
    void router.navigate({ to: '/dashboard/settings/groups' });
  }

  function handleCreate(values: GroupFormValues, memberIds: string[]) {
    createGroup.mutate(
      {
        name: values.name,
        description: values.description || undefined,
        managerId: values.managerId,
        memberIds: memberIds.length > 0 ? memberIds : undefined,
      },
      { onSuccess: close },
    );
  }

  return (
    <GroupForm
      mode="create"
      users={users}
      isPending={createGroup.isPending}
      onBack={close}
      onSubmit={handleCreate}
    />
  );
}
